export const cities94 = [
  { name: "Créteil", zip: "94000", time: "15 min", slug: "creteil" },
  { name: "Vitry-sur-Seine", zip: "94400", time: "20 min", slug: "vitry-sur-seine" },
  { name: "Saint-Maur-des-Fossés", zip: "94100", time: "20 min", slug: "saint-maur-des-fosses" },
  { name: "Champigny-sur-Marne", zip: "94500", time: "25 min", slug: "champigny-sur-marne" },
  { name: "Ivry-sur-Seine", zip: "94200", time: "20 min", slug: "ivry-sur-seine" },
  { name: "Maisons-Alfort", zip: "94700", time: "15 min", slug: "maisons-alfort" },
  { name: "Alfortville", zip: "94140", time: "20 min", slug: "alfortville" },
  { name: "Vincennes", zip: "94300", time: "25 min", slug: "vincennes" },
  { name: "Fontenay-sous-Bois", zip: "94120", time: "25 min", slug: "fontenay-sous-bois" },
  { name: "Saint-Mandé", zip: "94160", time: "25 min", slug: "saint-mande" },
  { name: "Nogent-sur-Marne", zip: "94130", time: "25 min", slug: "nogent-sur-marne" },
  { name: "Joinville-le-Pont", zip: "94340", time: "20 min", slug: "joinville-le-pont" },
  { name: "Charenton-le-Pont", zip: "94220", time: "20 min", slug: "charenton-le-pont" },
  { name: "Saint-Maurice", zip: "94410", time: "15 min", slug: "saint-maurice" },
  { name: "Choisy-le-Roi", zip: "94600", time: "20 min", slug: "choisy-le-roi" },
  { name: "Orly", zip: "94310", time: "25 min", slug: "orly" },
  { name: "Thiais", zip: "94320", time: "25 min", slug: "thiais" },
  { name: "Rungis", zip: "94150", time: "25 min", slug: "rungis" },
  { name: "Chevilly-Larue", zip: "94550", time: "25 min", slug: "chevilly-larue" },
  { name: "L'Haÿ-les-Roses", zip: "94240", time: "20 min", slug: "l-hay-les-roses" },
  { name: "Villejuif", zip: "94800", time: "20 min", slug: "villejuif" },
  { name: "Arcueil", zip: "94110", time: "20 min", slug: "arcueil" },
  { name: "Cachan", zip: "94230", time: "20 min", slug: "cachan" },
  { name: "Gentilly", zip: "94250", time: "20 min", slug: "gentilly" },
  { name: "Le Kremlin-Bicêtre", zip: "94270", time: "20 min", slug: "le-kremlin-bicetre" },
  { name: "Boissy-Saint-Léger", zip: "94470", time: "30 min", slug: "boissy-saint-leger" },
  { name: "Bonneuil-sur-Marne", zip: "94380", time: "25 min", slug: "bonneuil-sur-marne" },
  { name: "Bry-sur-Marne", zip: "94360", time: "25 min", slug: "bry-sur-marne" },
  { name: "Chennevières-sur-Marne", zip: "94430", time: "30 min", slug: "chennevieres-sur-marne" },
  { name: "Croissy-Beaubourg", zip: "77183", time: "35 min", slug: "croissy-beaubourg" },
  { name: "Fresnes", zip: "94260", time: "25 min", slug: "fresnes" },
  { name: "Limeil-Brévannes", zip: "94450", time: "30 min", slug: "limeil-brevannes" },
  { name: "Mandres-les-Roses", zip: "94520", time: "35 min", slug: "mandres-les-roses" },
  { name: "Marolles-en-Brie", zip: "94440", time: "35 min", slug: "marolles-en-brie" },
  { name: "Noiseau", zip: "94880", time: "35 min", slug: "noiseau" },
  { name: "Ormesson-sur-Marne", zip: "94490", time: "30 min", slug: "ormesson-sur-marne" },
  { name: "Périgny", zip: "94520", time: "35 min", slug: "perigny" },
  { name: "Queue-en-Brie", zip: "94510", time: "30 min", slug: "queue-en-brie" },
  { name: "Santeny", zip: "94440", time: "35 min", slug: "santeny" },
  { name: "Sucy-en-Brie", zip: "94370", time: "30 min", slug: "sucy-en-brie" },
  { name: "Valenton", zip: "94460", time: "25 min", slug: "valenton" },
  { name: "Villecresnes", zip: "94440", time: "35 min", slug: "villecresnes" },
  { name: "Villeneuve-le-Roi", zip: "94290", time: "25 min", slug: "villeneuve-le-roi" },
  { name: "Villeneuve-Saint-Georges", zip: "94190", time: "25 min", slug: "villeneuve-saint-georges" },
  { name: "Villiers-sur-Marne", zip: "94350", time: "25 min", slug: "villiers-sur-marne" },
  { name: "Ablon-sur-Seine", zip: "94480", time: "30 min", slug: "ablon-sur-seine" },
  { name: "Athis-Mons", zip: "91200", time: "30 min", slug: "athis-mons" },
];
